import React, { useState, useEffect } from "react";
import data from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Blog } from "./components/blog";
import Layout from "./components/layout";
import { Home } from "./components/home";
import { Privacy } from "./components/privacy";
import { ChatAiPrivacy } from "./components/chat-ai-privacy";
import { ChatAiTerms } from "./components/chat-ai-terms";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(data);
  }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index path="/" element={<Home data={landingPageData} />} />
          <Route index path="/blog" element={<Blog />} />
          <Route index path="/tomko-privacy" element={<Privacy />} />
          <Route index path="/chat-ai-privacy" element={<ChatAiPrivacy />} />
          <Route index path="/chat-ai-terms" element={<ChatAiTerms />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
